import { useEffect, useState, useCallback } from 'react';
import { FULFILLMENT_METHODS } from '../components/constants';
import { isQuantityLimitExceed } from '../components/helper/utils';

export const useHandleOnChange = ({
  onChange,
  getCurrentFulfillment,
  fulfillmentModels,
  availabilityType,
  selectedFulfillmentMethod,
  itemId,
  quantity,
  primaryStoreNum,
  isCartTiles,
  isBackorderedApplied
}) => {
  useEffect(() => {
    if (onChange && fulfillmentModels) {
      const currentFulfillment = getCurrentFulfillment(selectedFulfillmentMethod, fulfillmentModels);
      const currentFulfillmentMethod = currentFulfillment?.method || selectedFulfillmentMethod;
      const [storeObj = {}, shippingObj = {}] = fulfillmentModels;
      const isShowATC = !availabilityType?.discontinued
        && (shippingObj.enabled || storeObj.enabled);
      const disableATC = !shippingObj.enabled && storeObj.quantityLimitExceed;
      const isOutOfStockOnline = shippingObj.outOfStock ? shippingObj.outOfStock : false;
      const quantityLimitExceed = isQuantityLimitExceed({
        method: currentFulfillmentMethod,
        storeObj,
        shippingObj,
        expressObj: {}
      });
      const isPickupNearby = !!(storeObj?.isPickupNearby);
      const availableFulfillments = fulfillmentModels
        .filter((model) => model.enabled === true)
        .map((model) => (model.method));

      onChange({
        method: currentFulfillmentMethod,
        isShowATC,
        disableATC,
        isOutOfStockOnline,
        quantityLimitExceed: isBackorderedApplied ? false : quantityLimitExceed,
        availableFulfillments,
        isPickupNearby,
        primaryStoreNum
      });
    }
  }, [
    (!isCartTiles ? fulfillmentModels : null),
    itemId,
    // quantity,
    selectedFulfillmentMethod
  ]
  );
};